<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Program SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <div class="row">

                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renstra</span>
                                <select @change="getRenstraMisi()" class="form-control show-tick" v-model="id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Misi SKPD</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="renstra_misi_id">
                                    <option value="" >-- Semua Misi --</option>
                                    <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">{{data.uraian}}</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                    <table class="table-kiken1" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="tabel_center text-center" style="width: 5%" rowspan="2">Kode</th>
                            <th class="tabel_center text-center" style="width: 35%" rowspan="2">Urusan/Bidang/Program</th>

                            <th class="tabel_center text-center" style="width: 8" colspan="6">Jumlah Anggaran (Indikatif)</th>


                            <th class="tabel_center text-center" style="width: 18%" rowspan="2">#</th>
                        </tr>

                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="tabel_center " style="width: 7">Thn-1</th>
                            <th class="tabel_center " style="width: 7">Thn-2</th>
                            <th class="tabel_center " style="width: 7">Thn-3</th>
                            <th class="tabel_center " style="width: 7">Thn-4</th>
                            <th class="tabel_center " style="width: 7">Thn-5</th>
                            <th class="tabel_center " style="width: 7">Thn-6</th>

                        </tr>
                        </thead>
                        <tbody>

                            <template v-for="data1 in list_data">
                                <tr class="h_isitable_bold " :key="data1.renstra_sasaran_id">
                                    <!-- <td class="tabel_center text-center">1.</td> -->
                                    <td class="tabel_center ">{{data1.no_renstra_sasaran}}</td>
                                    <td class="tabel_center" >{{data1.renstra_sasaran_uraian}}</td>
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-justify"></td>
                                    
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-justify"></td>
                                    <td class="tabel_center text-center" >

                                    </td>
                                </tr>

                                <template v-for="data2 in data1.bidang">
                                    
                                    <tr class="h_isitable_bold2 " :key="data1.renstra_sasaran_id+data2.bidang_urusan_pemerintahan_id">
                                        <td class="tabel_center">{{data1.no_renstra_sasaran}}.{{data2.kode_bidang}}</td>
                                        <td class="tabel_center" >{{data2.nama_bidang}}</td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-justify"></td>
                                        <td class="tabel_center text-center" >
                                        </td>
                                    </tr>

                                    <template v-for="data3 in data2.program">
                                        <tr class="h_isitable" :key="data1.renstra_sasaran_id+data2.bidang_urusan_pemerintahan_id+data3.program_id">
                                            <td class="text-center" :style="cek_error_data(data1.no_renstra_sasaran)">
                                                

                                                <div v-if="!cek_error_sync(data3.program_pembangunan_id)">
                                                    <a @click="selectDataSync(data3, data2)" href="javascript:void(0);" title="Tidak Terkoneksi dengan Program Pembangunan RPJMD" data-toggle="modal" data-target="#m_konektifitas_data">
                                                        <i class="material-icons" style="color:#e04747">report</i>
                                                    </a>
                                                </div>
                                                <div v-if="cek_error_sync(data3.program_pembangunan_id)">
                                                    {{data1.no_renstra_sasaran}}.{{data2.kode_bidang}}.{{data3.program_kode}}
                                                </div>
                                            </td>
                                            <td class="" >{{data3.program_nama}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_1)}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_2)}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_3)}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_4)}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_5)}}</td>
                                            <td class="tabel_center text-justify">{{format_uang(data3.tahun_6)}}</td>

                                            <td class="tabel_center text-center" >
                                                <button @click="selectData(data3)" class="btn bg-light-blue btn-xs waves-effect" title="Pembagian Anggaran Per Tahun" id="edit_data" data-toggle="modal" data-target="#m_jml_anggaran_indikatif">
                                                    <i class="material-icons" >add_shopping_cart</i>
                                                </button>
                                                    &nbsp;
                                                <button @click="selectData(data3)" class="btn bg-light-green btn-xs waves-effect" title="Sasarab dan Indikator Program" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                    <i class="material-icons" >control_point</i>
                                                </button>
                                                    &nbsp;
                                                <button @click="selectDataMisiEdit(data3, data1)" class="btn bg-orange btn-xs waves-effect" title="Edit Misi dari Program" data-toggle="modal" data-target="#m_edit_sasaran">
                                                    <i class="material-icons" >done</i>
                                                </button>
                                                    &nbsp;
                                                <button @click="removeData(data3.renstra_program_pembangunan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>

                                        
                                        <form @submit.prevent="addData()">
                                            <div class="modal-body">

                                                

                                                <div v-if="!check_data_add" class="text-center">
                                                    <span> 
                                                        <i class="material-icons col-orange">warning</i> <br>
                                                        <b>MOHON PILIH MISI TERLEBIH DAHULU...!!!</b>
                                                    </span>
                                                </div>

                                                <div v-if="check_data_add">

                                                    <div class="row clearfix">
                                                        <div class="col-md-3 form-control-label">
                                                            <label for="kode">Sasaran SKPD</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select @change="getUrusan()" v-model="renstra_sasaran_id" class="form-control">
                                                                        <option v-for="data in list_renstra_sasaran" :value="data.renstra_sasaran_id" :key="data.renstra_sasaran_id">[{{data.no_renstra_sasaran}}] {{data.uraian}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-3 form-control-label">
                                                            <label for="kode">Urusan Pemerintahan</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select @change="getBidang()" v-model="urusan_pemerintahan_id" class="form-control">
                                                                        <option v-for="data in list_urusan" :value="data.urusan_pemerintahan_id" :key="data.urusan_pemerintahan_id">[{{data.kode_urusan}}] {{data.nama_urusan}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-3 form-control-label">
                                                            <label for="kode">Bidang Urusan Pemerintahan</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select @change="getProgram()" v-model="bidang_urusan_pemerintahan_id" class="form-control">
                                                                        <option v-for="data1 in list_bidang" :value="data1.bidang_urusan_pemerintahan_id" :key="data1.index">[{{data1.kode_bidang}}] {{data1.nama_bidang}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

        
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">

                                                                <th class="tabel_center text-center" style="width: 10%">Pilih</th>
                                                                <th class="tabel_center text-center" style="width: 10%">Kode</th>
                                                                <th class="tabel_center text-center" style="width: 80%">Program</th>
                                                                <!-- <th class="tabel_center text-center" style="width: 40%">Prioritas</th> -->
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr class="h_isitable" v-for="data in list_program" :key="data.program_pembangunan_id">
                                                                <td class="tabel_center text-center" >
                                                                    <input v-model="pilih_program" type="checkbox" :value="{program_pembangunan_id : data.program_pembangunan_id, program_id : data.program_id}" :id="data.program_pembangunan_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.program_pembangunan_id"></label>
                                                                </td>
                                                                <td class="tabel_center" >{{data.program_kode}}</td>
                                                                <td class="tabel_center text-justify">{{data.program_nama}}</td>
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

    
                                                </div>
                                            </div>

                                            <div class="modal-footer">
                                                


                                                <button v-if="!check_data_add" @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                                <button v-if="check_data_add" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button v-if="check_data_add" @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT MISI PROGRAM xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_edit_sasaran" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-orange">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">Edit Misi Program</h4> <span style="font-size:90%"><b><i>{{program_nama}}</i></b></span>
                                    </div>
                                <form>
                                    <div class="modal-body">

                                        
                                        <b>PERINGATAN : </b><span style="font-size:95%"><i>Jika data pada "Renstra Misi" kosong, harap kembali dan memilih periode renstra terlebih dahulu</i></span>
                                        <hr>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Renstra Misi</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select class="form-control" v-model="renstra_misi_id_edit" @change="getSasaranUpdate()">
                                                            <option value="" >-- Misi Kosong --</option>
                                                            <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">{{data.uraian}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Sasaran SKPD</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select @change="getUrusan()" v-model="renstra_sasaran_id_edit" class="form-control">
                                                            <option v-for="data in list_renstra_sasaran" :value="data.renstra_sasaran_id" :key="data.renstra_sasaran_id">[{{data.no_renstra_sasaran}}] {{data.uraian}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                       
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editDataMisiProgram()" type="submit" class="btn bg-orange waves-effect" >SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT MISI PROGRAM xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-xlg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">PENGATURAN DATA</h4>
                                    </div>

                                    <div class="modal-body">

                                        <!-- <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Kebijakan Umum</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select v-model="kebikan_umum_id" class="form-control">
                                                            <option value="" selected> -- Pilih Kebijakan Umum Pembangunan --</option>
                                                            <option v-for="data in list_kebijakan_umum" :value="data.kebikan_umum_id" :key="data.kebikan_umum_id">[{{data.no_renstra_kebijakan_umum}}] {{data.uraian}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                            <button type="button" class="btn bg-light-green btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data_indikator_xx">
                                                <!-- <i class="material-icons">add</i> -->
                                                TAMBAH INDIKATOR
                                            </button>
                                        
                                        <hr>

                                        <div class="table-responsive">
                                            <table class="table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-success kepala_table_f tabel_center">

                                                    <th class="tabel_center text-center" rowspan="2" style="width:5%">No</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:30%">Uraian Indikator</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:5%">Satuan</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:10%">Rumusan Satuan</th>

                                                    <th class="tabel_center text-center" colspan="8">Target</th>

                                                    <th class="tabel_center text-center" rowspan="2" style="width:10%">#</th>
                                                </tr>
                                                <tr class="bg-success kepala_table_f tabel_center">
                                                    <th class="tabel_center text-center" style="width:5%">Capaian Awal</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 1</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 2</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 3</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 4</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 5</th>
                                                    <th class="tabel_center text-center" style="width:5%">Tahun Ke 6</th>
                                                    <th class="tabel_center text-center" style="width:5%">Kondisi Akhir</th>
                                                </tr>
                                            </thead>
                                                <tbody>
                                                <tr class="h_isitablex" v-for="data in list_indikator" :key="data.indikator_program_pembangunan_id">
                                                    <td class="tabel_center text-center">{{data.no_indikator}}</td>
                                                    <td class="tabel_center" >{{data.uraian}}</td>
                                                    <td class="tabel_center text-center">{{data.satuan}}</td>
                                                    <td class="tabel_center text-center">{{data.rumus_satuan}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.capaian_awal)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_1)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_2)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_3)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_4)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_5)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.thn_6)}}</td>
                                                    <td class="tabel_center text-center">{{format_uang(data.kondisi_akhir)}}</td>

                                                    <td class="tabel_center text-center" >

                                                        <a href="javascript:void(0);" @click="SelectIndikator(data)" style="color:orange" title="Edit Data" data-toggle="modal" data-target="#m_edt_data_indikator">
                                                            <b> <i class="material-icons" >create</i></b>
                                                        </a>
                                                        &nbsp;
                                                        <a @click="RemoveIndikator(data.indikator_id)" href="javascript:void(0);" style="color:red;" title="Hapus Data">
                                                            <b> <i class="material-icons" >remove_circle</i></b>
                                                        </a>

                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                        </div>


                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editData()" type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_xx xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_tambah_data_indikator_xx" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">Indikator Renstra  Program Pembangunan</h4>
                                    </div>
                                <form>
                                    <div class="modal-body">

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Indikator</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Rumusan Satuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Capaian Awal</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 1</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 2</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 3</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 4</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 5</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Target Tahun 6</label>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Kondisi Akhir</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addIndikator()" type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_tambah_data_indikator_xx xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    
                    
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edt_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edt_data_indikator" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">Indikator Renstra Program Pembangunan</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">No Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.no_indikator" type="text" class="form-control" placeholder="Ex : 1">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Uraian Indikator</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.uraian" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.satuan" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Rumusan Satuan</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.rumus_satuan" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Capaian Awal</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.capaian_awal" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 1</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_1" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 2</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_2" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 3</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_3" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 4</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_4" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 5</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_5" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Target Tahun 6</label>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.thn_6" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row clearfix">
                                                <div class="col-md-2 form-control-label">
                                                    <label for="kode">Kondisi Akhir</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="indikator.kondisi_akhir" type="text" class="form-control" placeholder="Ex : ">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                    </div>
                                    <div class="modal-footer">
                                        <button @click="updateIndikator()" type="submit" class="btn bg-light-blue waves-effect" >SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                        
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_edt_data_indikator_kinerja xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KONEKTIFITAS DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_konektifitas_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <span style="font-size:120%">ATUR RELASI PROGRAM PEMBANGUNAN (RPJMD)</span> <br>
                                            <i><span style="font-size:80%">{{program_nama}}</span></i>
                                            
                                        </div>
                                        <form @submit.prevent="editDataSync()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Program Pembangunan (RPJMD)</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="program_pembangunan_id">
                                                                <option v-for="data in list_program" :key="data.program_pembangunan_id" :value="data.program_pembangunan_id">[{{data.program_kode}}]. {{data.program_nama}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-warning waves-effect">SINKRONISASI</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KONEKTIFITAS DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_jml_anggaran_indikatif xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal" id="m_jml_anggaran_indikatif" tabindex="-1" role="dialog" data-backdrop="static">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span></button>
                                        <h4 class="modal-title" id="largeModalLabel">ANGGARAN INDIKATIF</h4>
                                    </div>

                                    <div class="modal-body">

                                        <!-- <hr>
                                        <button v-on:click='cek_edit_anggaran = !cek_edit_anggaran' class="btn bg-light-blue waves-effect">
                                            <div v-if="!cek_edit_anggaran">
                                                ATUR DATA
                                            </div> 
                                            <div v-if="cek_edit_anggaran">
                                                KEMBALI
                                            </div>    
                                        </button> -->
                                        <!-- <br><br> -->
                                        <div class="table-responsive">
                                            <table class="table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="bg-blue kepala_table_f tabel_center">
                                                    <th class="tabel_center text-center" rowspan="2" style="width:50%">Uraian</th>
                                                    <th class="tabel_center text-center" rowspan="2" style="width:50%">Jumlah Anggaran (Indikatif)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 1</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_1" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_1)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 2</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_2" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_2)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 3</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_3" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_3)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 4</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_4" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_4)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 5</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_5" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_5)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="h_isitablex" >
                                                        <td class="tabel_center text-center">Tahun Ke - 6</td>
                                                        <td class="tabel_center text-center">
                                                            <div v-if="cek_edit_anggaran">
                                                                <input v-model="anggaran.tahun_6" type="number" class="form-control">
                                                            </div>
                                                            <div v-if="!cek_edit_anggaran">
                                                                Rp.{{format_uang(anggaran.tahun_6)}}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <hr>
                                        


                                    </div>
                                    <div class="modal-footer">
                                        <button v-if="cek_edit_anggaran" @click="editAnggaranInstansi()" type="submit" class="btn bg-orange waves-effect" >SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL m_jml_anggaran_indikatif xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>


    
    
    const ADD_URL_PROGRAM = URL_APP+'api/v1/planning_program_pembangunan/';
    const ADD_URL_KEBIJAKAN_UMUM = URL_APP+'api/v1/planning_renstra_kebijakan_umum/';
    const ADD_URL_PRIORITAS = URL_APP+'api/v1/planning_prioritas/';
    const ADD_URL_SATKER = URL_APP+'api/v1/planning_satker/';
  


    const ADD_URL = URL_APP+'api/v1/planning_renstra_program/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_RENSTRA_MISI = URL_APP+'api/v1/planning_renstra_misi/';
    const ADD_URL_RENSTRA_SASARAN = URL_APP+'api/v1/planning_renstra_sasaran/';
    const ADD_URL_URUSAN = URL_APP+'api/v1/planning_urusan/';
    const ADD_URL_BIDANG = URL_APP+'api/v1/planning_bidang/';

    import Autocomplete from 'vue2-autocomplete-js'
    const URL_SERVER = URL_APP;


    const ADD_URL_PEMBAGIAN_ANGGARAN = URL_APP+'api/v1/planning_program_pembangunan/';


    export default {
        name: "planning_urusan",
        components: { Autocomplete },
        data() {
            return {

   
                filter_rpjmd: '',
                filter_misi: '',
                filter_sasaran : '',

                rpjmd_id : '',
                rpjmd_periode : '',

                kebikan_umum_id : '',

                prioritas_id : '',
                prioritas_kode : '',
                prioritas_nama : '',

                program_pembangunan_id : '',
                keterangan : '',

                instansi_id : '',

                list_data: [],
                list_rpjmd: [],
                list_renstra_sasaran : [],
                list_urusan :[],
                
                list_kebijakan_umum :[],
                // list_prioritas :[],

                list_indikator : [],
                

                pilih_program : [],


                indikator : {
                    indikator_id : '',
                    renstra_program_pembangunan_id : '',
                    no_indikator : 0,
                    uraian : '',
                    satuan : '',
                    rumus_satuan : '',
                    capaian_awal : 0,
                    thn_1 : 0,
                    thn_2 : 0,
                    thn_3 : 0,
                    thn_4 : 0,
                    thn_5 : 0,
                    thn_6 : 0,
                    kondisi_akhir : 0,
                },

                anggaran : {
                    relasi_program_pembangunan_skpd_id : '',
                    tahun_1 : 0,
                    tahun_2 : 0,
                    tahun_3 : 0,
                    tahun_4 : 0,
                    tahun_5 : 0,
                    tahun_6 : 0,
                },
                cek_edit_anggaran : true,

                id_renstra : '',
                renstra_misi_id :'',
                renstra_misi_id_edit : '',
                renstra_program_pembangunan_id:'',


                cek_sasaran : false,
                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',

                renstra_sasaran_id : '',
                renstra_sasaran_id_edit : '',
                no_renstra_sasaran : '',
                sasaran_uraian : '',

                urusan_pemerintahan_id : '',
                kode_urusan : '',
                nama_urusan : '',

                bidang_urusan_pemerintahan_id : '',
                kode_bidang : '',
                nama_bidang : '',


                program_pembangunan_id : '',
                program_kode : '',
                program_nama : '',

                list_Renstra :[],
                list_Renstra_Misi : [],
                list_bidang :[],
                list_program :[],

                check_data_add : false,

                page_first : 1,
                page_last : 0,
                cari_value : '',
                token : localStorage.token,
                URL : URL_SERVER
            }
        },

        mounted() {

            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();
            this.getRenstra();
            // this.getPrioritas();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {

            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_misi_id : this.renstra_misi_id,
                        renstra_sasaran_id : this.renstra_sasaran_id,
                        unit_kerja : this.unit_kerja
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data);
                    this.list_data = res_data;
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id_renstra : this.id_renstra,
                        renstra_misi_id : this.renstra_misi_id,
                        renstra_sasaran_id : this.renstra_sasaran_id,
                        urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                        bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                        program_pembangunan_id : this.pilih_program,
                        unit_kerja : this.unit_kerja,
                        

                    })
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });

                // console.log(this.pilih_program);

                // console.log(this.pilih_program);
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_program_pembangunan_id : this.renstra_program_pembangunan_id,
                        renstra_kebijakan_umum_id : this.kebikan_umum_id


                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            editDataMisiProgram: function(){
                fetch(ADD_URL+'updateDataMisiProgram', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_program_pembangunan_id : this.renstra_program_pembangunan_id,
                        renstra_misi_id : this.renstra_misi_id_edit,
                        renstra_sasaran_id : this.renstra_sasaran_id_edit
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    // location.reload();
                    this.getData();
                });
            },
            removeData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            renstra_program_pembangunan_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },
            emptyData : function(){
                this.list_kebijakan_umum = [];
                this.list_indikator = [];
                this.pilih_program =[];

                this.renstra_sasaran_id = ''
                this.urusan_pemerintahan_id = ''
                this.bidang_urusan_pemerintahan_id = ''

                this.list_renstra_sasaran = [];
                this.list_urusan = [];
                this.list_bidang = [];
                this.list_program = [];

                // this.cek_edit_anggaran = false;


            },
            selectData : function(data){
                console.log(data);
                this.program_pembangunan_id = data.program_pembangunan_id;
                this.renstra_misi_id = data.renstra_misi_id;
                this.renstra_misi_id_edit = data.renstra_misi_id;
                this.renstra_program_pembangunan_id = data.renstra_program_pembangunan_id;
                this.program_nama = data.program_nama

                this.kebikan_umum_id = data.renstra_kebijakan_umum_id;
                this.indikator.renstra_program_pembangunan_id = data.renstra_program_pembangunan_id;


                this.anggaran.relasi_program_pembangunan_skpd_id =  data.relasi_program_pembangunan_skpd_id;
                this.anggaran.tahun_1 =  data.tahun_1;
                this.anggaran.tahun_2 =  data.tahun_2;
                this.anggaran.tahun_3 =  data.tahun_3;
                this.anggaran.tahun_4 =  data.tahun_4;
                this.anggaran.tahun_5 =  data.tahun_5;
                this.anggaran.tahun_6 =  data.tahun_6;


                this.getindikator();
                this.getKebijakan_umum();
            },
            selectDataMisiEdit : function(data, data_sasaran){
                console.log(data_sasaran);
                // this.renstra_misi_id = data.renstra_misi_id;
                this.renstra_misi_id_edit = data.renstra_misi_id;
                this.renstra_program_pembangunan_id = data.renstra_program_pembangunan_id;
                this.program_nama = data.program_nama;

                // this.renstra_sasaran_id = data_sasaran.renstra_sasaran_id;
                this.renstra_sasaran_id_edit = data_sasaran.renstra_sasaran_id;

                // this.getRenstra();
                this.getSasaranUpdate();



            },

            SelectIndikator : function(data){
                this.indikator = {
                    indikator_id : data.indikator_id,
                    renstra_program_pembangunan_id : data.renstra_program_pembangunan_id,
                    no_indikator : data.no_indikator,
                    uraian : data.uraian,
                    satuan : data.satuan,
                    rumus_satuan : data.rumus_satuan,
                    capaian_awal : data.capaian_awal,
                    thn_1 : data.thn_1,
                    thn_2 : data.thn_2,
                    thn_3 : data.thn_3,
                    thn_4 : data.thn_4,
                    thn_5 : data.thn_5,
                    thn_6 : data.thn_6,
                    kondisi_akhir : data.kondisi_akhir,
                };

            },

            editAnggaranInstansi : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL_PEMBAGIAN_ANGGARAN+'editDatarelasi_program_pembangunan_skpd', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.anggaran)
                }).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                    // this.cek_edit_anggaran = false;
                });
            },
            getindikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL_PROGRAM+'ReadRenstraIndikatorProgramPembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_program_pembangunan_id : this.indikator.renstra_program_pembangunan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_indikator = res_data;
                })
            },
            addIndikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL_PROGRAM+'addRenstraIndikatorProgramPembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then((res) => res.json()).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getindikator();
                })
            },

            updateIndikator : function(){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL_PROGRAM+'updateRenstraIndikatorProgramPembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.indikator)
                }).then((res) => res.json()).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getindikator();
                })
            },

            RemoveIndikator : function(id){
                // console.log(this.pilih_instansi);
                fetch(ADD_URL_PROGRAM+'RemoveRenstraIndikatorProgramPembangunan', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id : id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getindikator();
                })
            },
            selectDataSync : function(data, data2){
                console.log(data)
                // this.form = {
                //     rkpd_program_id : data.rkpd_program_id,
                //     rkpd_setup_id : data.rkpd_setup_id,
                //     bidang_urusan_pemerintahan_id : data.bidang_urusan_pemerintahan_id,
                //     program_pembangunan_id : data.program_pembangunan_id,
                //     program_id : data.program_id,
                //     realisasi_tahun_lalu : data.realisasi_tahun_lalu,
                //     pagu_indikatif : data.pagu_indikatif,
                //     prakiraan_maju : data.prakiraan_maju,
                //     program_nama : data.program_nama,
                // };

                // this.getDataTahun();
                // this.getOPD();
                this.renstra_program_pembangunan_id = data.renstra_program_pembangunan_id
                this.bidang_urusan_pemerintahan_id = data2.bidang_urusan_pemerintahan_id
                this.getProgram();
            },
            editDataSync : function(){
                fetch(ADD_URL+'updateDataSync', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        program_pembangunan_id : this.program_pembangunan_id,
                        renstra_program_pembangunan_id : this.renstra_program_pembangunan_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

            // =================================== TAMBAHAN ==================================

                getRenstra : function(){
                    this.page_first = 1;
                    fetch(ADD_URL_RENSTRA, {
                        method : 'POST',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        },
                        body : JSON.stringify({
                            unit_kerja : this.unit_kerja
                        })
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_Renstra = res_data;
                        // this.id_renstra = res_data[0].id_renstra
                        this.getData();
                        // console.log(res_data);
                    })
                },

                getRenstraMisi : function(){
                    this.page_first = 1;
                    if (this.id_renstra == '') {
                        this.renstra_misi_id = '';
                        this.list_Renstra_Misi = [];
                    }else{
                        fetch(ADD_URL_RENSTRA_MISI, {
                            method : 'POST',
                            headers : {
                                'content-type': 'application/json',
                                authorization : 'kikensbatara '+ localStorage.token
                            },
                            body : JSON.stringify({
                                unit_kerja : this.unit_kerja
                            })
                        }).then(res => res.json()).then((res_data)=>{
                            this.list_Renstra_Misi = res_data;
                            // console.log(res_data);
                        })

                    }
                },

                getSasaran: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_RENSTRA_SASARAN, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            renstra_misi_id : this.renstra_misi_id,
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            console.log(res_data);
                            this.list_renstra_sasaran = res_data
                            this.getData();
                    })
                },
                getSasaranUpdate: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_RENSTRA_SASARAN, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            renstra_misi_id : this.renstra_misi_id_edit,
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            console.log(res_data);
                            this.list_renstra_sasaran = res_data
                    })
                },

                getUrusan: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_URUSAN, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_urusan = res_data
                    })
                },

                getBidang: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_BIDANG+'reqRenstra', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            urusan_pemerintahan_id : this.urusan_pemerintahan_id,
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            // console.log(res_data);
                            this.list_bidang = res_data;
                    })
                },

                getProgram: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    // console.log(this.bidang_urusan_pemerintahan_id);
                    fetch(ADD_URL_PROGRAM, {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            bidang_urusan_pemerintahan_id : this.bidang_urusan_pemerintahan_id,
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                        
                        
                        var list_data = this.list_data
                            list_data.forEach(data_list => {
                                data_list.bidang.forEach(bidang_list => {
                                    bidang_list.program.forEach(program_list => {
                                        // console.log(program_list);

                                        for( var i = 0; i < res_data.length; i++){ 
                                            if ( res_data[i].program_pembangunan_id == program_list.program_pembangunan_id) {
                                                res_data.splice(i, 1); 
                                            }
                                        }

                                    });
                                });
                            });

                            // console.log(res_data);
                            
                            this.list_program = res_data;


                            // this.getPrioritas();
                    })
                },
                getKebijakan_umum: function(){
                    if (this.filter_misi == '') {
                        this.filter_sasaran = '';
                    }
                    fetch(ADD_URL_KEBIJAKAN_UMUM+'program_pembangunan', {
                        method : 'POST',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            renstra_misi_id : this.renstra_misi_id,
                            unit_kerja : this.unit_kerja,
                        })

                    }).then(res => res.json()).then((res_data)=>{
                            this.list_kebijakan_umum = res_data;
                            // console.log(res_data);
                    })
                },

                cek_error_data : function(data){
                    if (data == '' || data == null || data == undefined) {
                        return 'background : #ffd9cc'
                    } else {
                        return ''
                    }
                },

                cek_error_sync : function(data){
                    if (data == '' || data == null || data == undefined) {
                        return false
                    } else {
                        return true
                    }
                },
        


            // =================================== TAMBAHAN ==================================

            // ================== AUTOCOMPLETE ====================
                renderChild(data) {
                    return `
                    <span><b>${data.unit_kerja}</b></span>
                    <span style='font-size:80%'>${data.ref_instansi}</span>
                    `
                },
                getAuto : function(obj){
                    this.unit_kerja = obj.id;
                    this.unit_kerja_full = obj.unit_kerja;
                    this.getRenstra();
                    // console.log(obj);
                },
            // ================== AUTOCOMPLETE ====================
            // =================================== PAGINASI ==================================
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
                },

                btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
                },
                btn_check_data_add : function(){
                    if (this.id_renstra != '' && this.renstra_misi_id != '') {
                        this.check_data_add = true;
                        this.getSasaran();
                    }
                },

                cari_data : function(){
                    this.page_first = 1;
                    this.getData();
                },
                format_uang : function(angka, prefix){
                    if (angka == null || angka == '' || angka == undefined || angka == 0 || angka == '0') {
                        return '0'
                    } else {
                        var rupiah = '';		
                        var angkarev = angka.toString().split('').reverse().join('');
                        for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                        return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                    }

                    // return angka
                },


            // =================================== PAGINASI ==================================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
